import { render, staticRenderFns } from "./RegenTemplatesList.vue?vue&type=template&id=744460ec&"
import script from "./RegenTemplatesList.js?vue&type=script&lang=js&"
export * from "./RegenTemplatesList.js?vue&type=script&lang=js&"
import style0 from "./RegenTemplatesList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports